import React, { Component } from "react";
// import { adminLabels } from '../../redux/constant/admin-label-constant';

class ConfirmAlert extends Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	alertType = (type) => {
		return this.props.msgType === type ?
			<div className='custom-ui'>
				<div className="react-confirm-alert-body text-center">
					<div><i className="pe-7s-img" style={{ "fontSize": "40px", "color": "red" }}></i></div>
					<h3 style={{ "color": "#4f7bea", "fontSize": "20px" }}>{this.props.header}</h3>
					<p className="marginFromTopPopUp" >{this.props.description} </p>
					<div className="react-confirm-alert-button-group alignFlexButtons">
						<button className="btn btn-success" onClick={this.props.onClosePro()}>
							<i className="pe-7s-check"></i> OK
					</button>
					</div>
				</div>
			</div>
			:
			<div className='custom-ui'>
				<div className="react-confirm-alert-body text-center">
					<div><i className="pe-7s-img" style={{ "fontSize": "40px", "color": "red" }}></i></div>
					<h3 style={{ "color": "#4f7bea", "fontSize": "20px" }}>{this.props.header}</h3>
					<p className="marginFromTopPopUp" >{this.props.description} </p>
					{
						this.props.extraHtml &&
						this.props.extraHtml()
					}
					<div className="react-confirm-alert-button-group alignFlexButtons">
						<button onClick={() => {
							if (this.props.onNo)
								this.props.onNo();
							this.props.onClosePro()}} className="btn btn-danger"><i className="pe-7s-close-circle"></i> No</button>
						<button className="btn btn-success" onClick={() => {this.handleOnYesClick()}}>
							<i className="pe-7s-check"></i> Yes</button>
					</div>
				</div>
			</div>
	}

	handleOnYesClick = () => {
		this.props.onYes();
		this.props.onClosePro();
	}
	render() {
		return (
			<React.Fragment>
				{this.alertType('warning')}
			</React.Fragment>
		);
	};
}



export default ConfirmAlert;



// WEBPACK FOOTER //
// ./src/components/ThemeComponents/confirmAlert.jsx